import React, { CSSProperties, FC, ReactNode } from 'react'
import { Row, RowProps } from 'antd'

import { CssScrollerDiv, TCssScrollerProps } from 'src/storybook/components'

type TLayoutFormScrollableProps = {
  scrollerClass?: string
  cssScroller?: TCssScrollerProps
  footer?: ReactNode
  rowProps?: RowProps
  footerContainerStyle?: CSSProperties
}

const LayoutFormScrollable: FC<TLayoutFormScrollableProps> = ({
  scrollerClass,
  cssScroller,
  footer,
  rowProps,
  children,
  footerContainerStyle,
}) => {
  return (
    <div className="wh-vertical-scroller-container">
      <div
        className="wh-vertical-scroller-container-scroll"
        style={{ width: '100%' }}
      >
        <CssScrollerDiv
          defaultYScroller
          className={scrollerClass}
          {...cssScroller}
        >
          <Row {...rowProps}>{children}</Row>
        </CssScrollerDiv>
      </div>
      {footer && <div style={{ ...footerContainerStyle }}>{footer}</div>}
    </div>
  )
}

export default LayoutFormScrollable
